import React from "react";
import { Layout } from "antd";
import Sidebar from "./Sidebar";
import ContentComponent from "./Content";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <Layout hasSider>
      <Sidebar />
      <Layout>
        <ContentComponent>{children}</ContentComponent>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
